import { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, IconButton, Typography } from "@mui/material"
import { useFormik } from "formik"
import { useState } from "react"
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext"
import { NewPasswordValidation } from "../../../interfaces/validation/NewPasswordValidation"
import { sxButtonOptionRecovery, sxTypographyTitle } from "../sxProps"
import { PasswordRedefinitionProps } from "../../../interfaces/props/passwordRecovery/PasswordRedefinitionProps"
import PasswordInput from "../../../components/PasswordInput"


const PasswordRedefinition: React.FC<PasswordRedefinitionProps> = ({ formBack, passwordRegister }) => {
  const [lengthValid, setLengthValid] = useState(false);
  const [uppercaseValid, setUppercaseValid] = useState(false);
  const [lowercaseValid, setLowercaseValid] = useState(false);
  const [numberValid, setNumberValid] = useState(false);
  const [specialCharValid, setSpecialCharValid] = useState(false);
  const [enableButtonChange, setEnableButtonChange] = useState(false);


  const { textStyleAccessibility, buttonStyleAccessibility, buttonTextStyleAccessibility } = useAccessibility();

  const formik = useFormik({
    initialValues: { password: '', passwordConfirmation: '' },
    validationSchema: NewPasswordValidation,
    onSubmit: (values) => {
      passwordRegister(values.password);
    },
    validateOnChange: false
  });


  const handleFieldChange = (fieldName: string, value: string) => {
    formik.setFieldValue(fieldName, value.trim());

    // Mínimo de 10 caracteres
    setLengthValid(value.length >= 10);

    // Pelo menos uma letra maiúscula
    setUppercaseValid(/[A-Z]/.test(value));

    // Pelo menos uma letra minúscula
    setLowercaseValid(/[a-z]/.test(value));

    // Pelo menos um número
    setNumberValid(/\d/.test(value));

    // Pelo menos um caractere especial
    setSpecialCharValid(/[@#$&]/.test(value));

    if ((value.length >= 10)
      && (/[A-Z]/.test(value))
      && (/[a-z]/.test(value))
      && (/\d/.test(value))
      && (/[@#$&]/.test(value))) {
      setEnableButtonChange(true)
    } else {
      setEnableButtonChange(false)
    }
  };

  return (
    <div style={textStyleAccessibility} className='container-login-painel-rigth'>
      <div className='password-recovery-container-text'>
        <div className='width-100'>
          <IconButton onClick={() => formBack()} type="button">
            <FontAwesomeIcon style={textStyleAccessibility} icon={faArrowLeft as IconDefinition} className='search-icon' />
          </IconButton>
          <Typography component="h1" style={textStyleAccessibility} sx={sxTypographyTitle} className='margin-bottom-painel-rigth'>Redefinir senha</Typography>
        </div>
        <div className='container-text-recovery '>
          <span style={textStyleAccessibility} className='login-text login-text-center'>Informe sua nova senha de acesso.</span>
        </div>
      </div>
      <form onSubmit={formik.handleSubmit} className='width-100'>
        <div className='width-100'>
          <div className='width-100 margin-bottom-20'>
            <PasswordInput
              label="Nova senha"
              placeholder='Digite sua nova senha'
              name='password'
              textError={formik.errors.password}
              error={!!formik.errors.password || !!formik.errors.passwordConfirmation}
              maxLength={30}
              onChange={e => handleFieldChange('password', e.target.value)}
              fullWidth />
          </div>
          <div className='width-100 margin-bottom-20'>
            <PasswordInput
              label="Confirmar nova senha"
              placeholder='Confirmar nova senha'
              name='passwordConfirmation'
              textError={formik.errors.password}
              error={!!formik.errors.password || !!formik.errors.passwordConfirmation}
              maxLength={30}
              onChange={formik.handleChange}
              fullWidth />
          </div>
        </div>
        <div style={{ gap: '24px', display: 'flex', flexDirection: 'column' }}>
          <Button style={buttonStyleAccessibility} disabled={!enableButtonChange} type='submit' sx={sxButtonOptionRecovery} variant='contained'>
            <Typography style={buttonTextStyleAccessibility}>ATUALIZAR SENHA</Typography>
          </Button>
        </div>
      </form>
      <div>
        <Typography>Por questões de segurança, a sua senha deve seguir os seguintes critérios:</Typography>
        <Typography sx={lengthValid ? { color: 'green' } : { color: 'red' }}>{`${lengthValid ? `\u2713` : `X`} Mínimo de 10 caracteres`}</Typography>
        <Typography sx={uppercaseValid ? { color: 'green' } : { color: 'red' }}>{`${uppercaseValid ? `\u2713` : `X`} Pelo menos uma letra maiúscula`}</Typography>
        <Typography sx={lowercaseValid ? { color: 'green' } : { color: 'red' }}>{`${lowercaseValid ? `\u2713` : `X`} Pelo menos uma letra minúscula`}</Typography>
        <Typography sx={numberValid ? { color: 'green' } : { color: 'red' }}>{`${numberValid ? `\u2713` : `X`} Pelo menos um número`}</Typography>
        <Typography sx={specialCharValid ? { color: 'green' } : { color: 'red' }}>{`${specialCharValid ? `\u2713` : `X`} Pelo menos um caractere especial (Ex: # @ $ &)`}</Typography>
      </div>
    </div>
  )
}

export default PasswordRedefinition